import { RelodeErrorBase } from "./relodeErrorBase";

export class ApplicationError extends RelodeErrorBase {
    public type: "react" | string;
    public info: string;

    constructor(message: string) {
        super("ApplicationError: " + message);
    }

    getTelemetryData = () => {
        const data = {
            type: this.type,
            info: this.info,
            origin: this.origin,
        };

        return data;
    };

    public static fromError = (error: Error) => {
        const err = new ApplicationError(error.message);
        err.name = error.name;
        err.stack = error.stack;
        err.type = getErrorType(error);
        return err;
    };

    public static fromUnknown = (message: string) => {
        const err = new ApplicationError(message);
        err.name = "unknown application error";
        err.stack = "no stack trace";
        err.type = "unknown";
        return err;
    };
}

const getErrorType = (error: Error) => {
    if (error instanceof TypeError) return "TypeError";
    if (error instanceof SyntaxError) return "SyntaxError";
    if (error instanceof EvalError) return "EvalError";
    if (error instanceof RangeError) return "RangeError";
    if (error instanceof ReferenceError) return "ReferenceError";
    if (error instanceof SyntaxError) return "SyntaxError";
    if (error instanceof URIError) return "URIError";
    return "unknown";
};

export const createApplicationError = (error: any) => {
    if (error instanceof ApplicationError) return error;
    const message = typeof error === "object" ? JSON.stringify(error) : error;
    const err = new ApplicationError(message);
    return err;
};
